/**
 * フッター: PC では details を常に開き・サマリーをフォーカス対象外にする（アコーディオン無効）
 * SP（768px以下）では閉じた状態からネイティブの開閉のみ
 */
(function () {
  var mq = window.matchMedia("(min-width: 769px)");

  function syncFooterMenuDetails() {
    var footer = document.getElementById("footer");
    if (!footer) return;

    var list = footer.querySelectorAll(".footer_menu_details");
    if (!list.length) return;

    var isPc = mq.matches;
    for (var i = 0; i < list.length; i++) {
      var details = list[i];
      var summary = details.querySelector("summary");
      if (isPc) {
        details.open = true;
        if (summary) summary.tabIndex = -1;
      } else {
        details.open = false;
        if (summary) summary.removeAttribute("tabindex");
      }
    }
  }

  function init() {
    syncFooterMenuDetails();
    if (typeof mq.addEventListener === "function") {
      mq.addEventListener("change", syncFooterMenuDetails);
    } else {
      mq.addListener(syncFooterMenuDetails);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
